import React from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";

export default function GiftThankYou() {
  const navigate = useNavigate();

  return (
    <div className="gift-thank-you-page">
      <section className="gift-thank-you-card">
        <div
          className="gift-thank-you-hero"
          role="img"
          aria-label="A welcoming group of people reaching out their hands"
        />
        <div className="gift-thank-you-fade" />

        <div className="gift-thank-you-content">
          <div className="gift-thank-you-eyebrow">Your gift is received</div>

          <h1 className="gift-thank-you-title">
            You&apos;re part of
            <br />
            <em>something beautiful</em> now.
          </h1>

          <p className="gift-thank-you-body">
            Because of your generosity, someone else will be welcomed into this
            community and helped to feel the love that&apos;s never left.
          </p>

          <p className="gift-thank-you-note">
            Thank you for passing some of that love forward.
          </p>

          <button
            type="button"
            className="gift-thank-you-cta"
            onClick={() => navigate("/")}
          >
            Return to VerySoul
          </button>

          <div className="gift-thank-you-signoff">
            <div className="gift-thank-you-team">
              With deep gratitude, the VerySoul community
            </div>
            <div className="gift-thank-you-tagline">
              Helping you feel the love that&apos;s never left.
            </div>
            <div className="gift-thank-you-pillars">
              <span>Evidence</span>
              <span className="dot">&bull;</span>
              <span>Inspiration</span>
              <span className="dot">&bull;</span>
              <span>Empowerment</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
